module.exports = __webpack_public_path__ + "static/fox-bingo-576137f9e9af741b6f53b36dfbc1dc3e.png";